<template>
  <div v-if="visible" class="modal-overlay" @click="close">
    <div class="modal-content" @click.stop>
      <button class="close-button" @click="close">✕</button>
      <img :src="imageUrl" class="image-viewer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, required: true },
    imageUrl: { type: String, required: true }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
}

.modal-content {
  background: #fff;
  width: 85%;
  max-width: 1200px;
  height: 90%;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.close-button {
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
  padding: 10px;
  align-self: flex-end;
}

.image-viewer {
  flex: 1;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f5f5f5;
}
</style>
